'use client';

import { Language } from '@whoop/i18n';
import { usePathname } from 'next/navigation';

interface Locale {
  country: string;
  language: Language;
}

export default function useLocale(): Locale {
  const pathname = usePathname();
  const [, country, language] = pathname.split('/');
  return {
    country,
    language: language as Language,
  };
}
